"use client";

import { Button } from "@/ui";

export interface CTACardColumnsProps {
  title?: string;
  subtitle?: string;
  cards?: { title: string; description: string }[];
  primaryLabel?: string;
  onPrimaryClick?: () => void;
}

const defaultCards = [
  {
    title: "Reserve a Table",
    description: "Secure your preferred time and seating.",
  },
  {
    title: "Chef's Picks",
    description: "Explore this week's signature specials.",
  },
  {
    title: "Private Events",
    description: "Host an unforgettable evening with us.",
  },
];

export default function CTACardColumns({
  title = "Create your perfect evening",
  subtitle = "Choose your path to a memorable dining experience.",
  cards = defaultCards,
  primaryLabel = "Get Started",
  onPrimaryClick,
}: CTACardColumnsProps) {
  return (
    <section className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-8">
        <h3 className="text-4xl md:text-5xl font-bold text-black mb-2">
          {title}
        </h3>
        <p className="text-lg text-black/70">{subtitle}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {cards.map((c) => (
          <div
            key={c.title}
            className="rounded-2xl border border-black/10 bg-white/60 backdrop-blur p-6 text-left"
          >
            <h4 className="text-xl font-semibold text-black mb-2">{c.title}</h4>
            <p className="text-black/70">{c.description}</p>
          </div>
        ))}
      </div>
      <div className="text-center">
        <Button
          type="button"
          variant="primary"
          size="lg"
          onClick={onPrimaryClick}
          className="rounded-full"
        >
          {primaryLabel}
        </Button>
      </div>
    </section>
  );
}
